import React from "react";
import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard";
import styles from "./Pineapple.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const Pineapple = () => {
  const { t } = useLanguage();

  const pineappleProducts = [
    {
      title: t("pineapple.products.valmisRings.title"),
      image: "/assets/products/pineapple/can_ananas_slices_ua.png",
      weight: t("pineapple.products.valmisRings.weight"),
      description: t("pineapple.products.valmisRings.description"),
    },
    {
      title: t("pineapple.products.valmisChunks.title"),
      image: "/assets/products/pineapple/can_ananas_chunks_ua.png",
      weight: t("pineapple.products.valmisChunks.weight"),
      description: t("pineapple.products.valmisChunks.description"),
    },
    {
      title: t("pineapple.products.ananasoffRings.title"),
      image: "/assets/products/pineapple/can_ananasoff_7.png",
      weight: t("pineapple.products.ananasoffRings.weight"),
      description: t("pineapple.products.ananasoffRings.description"),
    },
    {
      title: t("pineapple.products.ananasoffChunks.title"),
      image: "/assets/products/pineapple/can_ananasoff_5.png",
      weight: t("pineapple.products.ananasoffChunks.weight"),
      description: t("pineapple.products.ananasoffChunks.description"),
    },
  ];

  return (
    <Layout>
      <h2 className={styles.heading}>{t("pineapple.title")}</h2>

      <div className={styles.grid}>
        {pineappleProducts.map((p, i) => (
          <ProductCard key={i} {...p} />
        ))}
      </div>
    </Layout>
  );
};

export default Pineapple;
